import styled from 'styled-components';

import { fontFamilySize, px } from '../../../contrib/ui';

export const StyledEditableDistanceFields = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .field {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    margin-right: ${px(20)};

    .number-container {
      ${fontFamilySize('Bold', 16)}
      color: var(--dark);
      margin-right: ${px(5)};
    }

    .unit {
      ${fontFamilySize('Heavy', 18)}
      color: var(--grey9b);
    }
  }
`;
